// extracted by mini-css-extract-plugin
export default {"message":"NotFound_message__wMvZd","wrapper":"NotFound_wrapper__KwR49","bgTop":"NotFound_bgTop__6L-kp","freeSpace":"NotFound_freeSpace__9MeTs"};